export default __webpack_public_path__ + "static/media/gallery1.503c9c3e.png";